'use strict';

let formValidation = require('../components/formValidation');
const { isEmpty } = require('lodash');

const STATES = {
    initial: 'initial',
    amount: 'amount',
    form: 'form'
};
var currentState = STATES.initial;

const SELECTORS = {
  formSubmit: '.gift-certificate-balance__form-submit',
  label: '.gift-certificate-balance__message-balance',
  inputCardNumber: '.gift-certificate-balance__form-cardNumber',
  inputEmail : '.gift-certificate-balance__form-email'
}

module.exports = {
    test: function () {
        $("input").on('keyup',function() {
            if (!isEmpty($(SELECTORS.inputCardNumber).val())) {
                $(SELECTORS.formSubmit).removeClass('disabled');
            } else {
                $(SELECTORS.formSubmit).addClass('disabled');
            }
        });
    },
    submit: function () {
      $(SELECTORS.formSubmit).on('click', function (e) {
          let form = $(e.currentTarget).closest('form');
          e.preventDefault();
          let url = form.attr('action');
          console.log(form.serialize());
          //form.spinner().start();
          $('form.login').trigger('login:submit', e);
          $.ajax({
            url: url,
            currentState:currentState,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
              if (data.dataLayer) {
                window.dataLayer.push(data.dataLayer);
              }
              var balance_number = data.balance;
              var currency_symbol = data.currencySymbol;
              var amount_balance_label = data.amount;
              if (currency_symbol && balance_number && amount_balance_label) {
                  var labelBalance = $('<p>').text(amount_balance_label + ' ' + balance_number + ' ' + currency_symbol);
                  $(SELECTORS.label).html(labelBalance);
                  $(SELECTORS.formSubmit).addClass('d-none');
              }

              $("input").on('focus',function() {
                if($(SELECTORS.formSubmit).hasClass('d-none')) {
                  $(SELECTORS.formSubmit).removeClass('d-none');
                }
              });
              if (!data.success) {
                var labelBalance = $('<span>').text(data.errorMsg);
                $(SELECTORS.label).html(labelBalance);
                $('form.giftcertificateform').trigger('giftcertificate:error', data);
              } else {
                $('form.giftcertificateform').trigger('giftcertificate:success', data);
              }
            },
            error: function (data) {
              console.log('errore');
              if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
              } else {
                $('form.giftcertificateform').trigger('giftcertificate:error', data);
                //form.spinner().stop();
              }
            },
          });
          return false;
        });
      },
}
